import { addRest, getFieldParser, getValue, number_or_0, objectid_array_or_empty, objectid_or_0, } from '../../utils/parser-utils';
//34
const interval_timetables_fields = [
    { name: 'time_intervals', ...objectid_array_or_empty },
    { name: 'outside_default', ...objectid_or_0, default_from_op: 2730 },
    { name: 'setting_register', ...number_or_0 },
];
const { toStr } = getFieldParser(interval_timetables_fields);
function intervalTimeTableFromStr(id, params) {
    return {
        id: id,
        time_intervals: getValue(params, 0, 0),
        outside_default: getValue(params, 1, 0),
        setting_register: getValue(params, 2, 0),
        ...addRest(params, 3),
    };
}
export const interval_timetable_parser = {
    toStr: toStr,
    fromStr: intervalTimeTableFromStr,
};
